import { render, staticRenderFns } from "./PayCommission.vue?vue&type=template&id=5cebc674&"
import script from "./PayCommission.vue?vue&type=script&lang=js&"
export * from "./PayCommission.vue?vue&type=script&lang=js&"
import style0 from "./PayCommission.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports